import React from 'react';
import addDays from 'date-fns/addDays';
import subDays from 'date-fns/subDays';
import isBefore from 'date-fns/isBefore';
import isEqual from 'date-fns/isEqual';

import OpeningsCalendar from '../../../legacyCore/OpeningsCalendar';
import CalendarOpening from '../../../shared/components/CalendarOpening';

import { toDateNonNullable } from '../../../shared/utils/toDate';

export default function ProviderCalendar(props) {
  const { provider, openingsData, reasonForVisit, schedule } = props;
  const {
    values: { minDate, selectedDate },
    updateSelectedDate,
  } = schedule;

  return (
    <OpeningsCalendar
      selectedDate={selectedDate}
      minDate={minDate}
      phoneNumber={provider.office.phone}
      display={provider.display}
      reasonForVisitName={reasonForVisit.name}
      timeZone={provider.office.timeZoneCode}
      loading={openingsData.loading}
      openings={openingsData.openings ? openingsData.openings.nodes : []}
      nextAvailableDate={openingsData.openings && openingsData.openings.pageInfo.nextAvailableDate}
      onPreviousClick={() => updateSelectedDate(subDays(toDateNonNullable(selectedDate), 7))}
      onNextClick={() => updateSelectedDate(addDays(toDateNonNullable(selectedDate), 7))}
      onNextAvailableClick={(date) => updateSelectedDate(date)}
      disablePrevious={
        isBefore(toDateNonNullable(selectedDate), toDateNonNullable(minDate)) ||
        isEqual(toDateNonNullable(selectedDate), toDateNonNullable(minDate))
      }
      renderOpening={(renderProps) => <CalendarOpening isOnWidget {...renderProps} />}
    />
  );
}
